<template>
  <span class="waste-pill" :class="`waste-pill--${status}`">
    <span class="waste-pill__dot" :style="dotStyle" aria-hidden="true" />
    {{ $t(status) }}
  </span>
</template>

<script>
// status is one of pending | approved | rejected | cancelled; each key already
// exists in every locale file.
//
// The dot takes its colour from the live Vuetify theme (so it follows light/dark
// mode); cancelled has no theme colour and keeps the neutral CSS default.
const THEME_COLOR = {
  pending: "warning",
  approved: "success",
  rejected: "error",
};

export default {
  name: "WasteStatusPill",
  props: {
    status: { type: String, required: true },
  },
  computed: {
    dotStyle() {
      const name = THEME_COLOR[this.status];
      const color = name && this.$vuetify.theme.currentTheme[name];
      return color ? { background: color } : {};
    },
  },
};
</script>

<style scoped>
.waste-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border: 1px solid var(--app-border);
  border-radius: 999px;
  background: var(--app-field-bg);
  color: var(--app-text-primary);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.waste-pill__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--app-text-muted);
}

.waste-pill--pending {
  border-color: var(--app-warning-soft-border);
  background: var(--app-warning-soft-bg);
}

.waste-pill--approved {
  border-color: var(--app-success-soft-border);
  background: var(--app-success-soft-bg);
}

.waste-pill--rejected {
  border-color: var(--app-error-soft-border);
  background: var(--app-error-soft-bg);
}
</style>
